function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionUnhappyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16.003C2 8.283 8.28 2.002 16 2.002s14 6.28 14 14-6.28 14.001-14 14.001-14-6.28-14-14zm1.975 0c0 6.63 5.394 12.025 12.025 12.025 6.63 0 12.025-5.395 12.025-12.026 0-6.63-5.395-12.025-12.025-12.025-6.63 0-12.025 5.395-12.025 12.025z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.704 14.764a1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.859-1.859 1.86 1.86 0 00-1.858 1.859 1.86 1.86 0 001.858 1.858zM21.296 14.764a1.86 1.86 0 001.858-1.858 1.86 1.86 0 00-1.858-1.859 1.86 1.86 0 00-1.859 1.859 1.86 1.86 0 001.858 1.858zM16 18.327c-3.377 0-6.386 1.58-7.237 3.044a.894.894 0 101.546.899c.45-.773 2.736-2.155 5.69-2.155 2.9 0 5.074 1.386 5.762 2.26a.894.894 0 001.405-1.108c-1.117-1.416-3.835-2.94-7.166-2.94z",
    fill: props.color
  }));
}

export default SvgIconEmotionUnhappyFilled;